import type { CartRepository } from '../../domain/repositories/CartRepository';

export class RemoveFromCartUseCase {
  constructor(private repository: CartRepository) {}

  async execute(itemId: string) {
    return await this.repository.removeItem(itemId);
  }
}
